import http from '@root/utils/axios/admin';

let state = {
    CarMakesList: [],
    CarMake: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchCarMakesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/car-makes', { params: filter }).then((response) => {
                commit('setCarMakesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },



    fetchCarMake({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/car-makes/' + id).then((response) => {
                commit('setCarMake', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },




}


let mutations = {
    setCarMakesList(state, data) {
        state.CarMakesList = data;
    },
    setCarMake(state, data) {
        state.CarMake.data = data;
    },
}

export default {
    state,
    actions,
    mutations
}